export const VERSIONS_FETCHED_OEM = "VERSIONS_FETCHED_OEM";
export const COUNTRIES_FETCHED_OEM = "COUNTRIES_FETCHED_OEM";
export const MODELS_FETCHED_OEM = "MODELS_FETCHED_OEM";
export const SELECTED_VERSIONS_UPDATED_OEM = "SELECTED_VERSIONS_UPDATED_OEM";
export const APP_LIST = "APP_LIST";
export const SELECTED_APP_OEM = "SELECTED_APP_OEM";
export const SELECTED_COUNTRIES_UPDATED_OEM = "SELECTED_COUNTRIES_UPDATED_OEM";
export const SELECTED_MODELS_UPDATED = "SELECTED_MODELS_UPDATED";
export const START_DATE_FETCHED_OEM = "START_DATE_FETCHED_OEM";
export const SELECTED_DATE_RANGE_UPDATED_OEM = "SELECTED_DATE_RANGE_UPDATED_OEM";
export const OEM_COUNTRY_DISTRIBUTION = "OEM_COUNTRY_DISTRIBUTION";
export const RESET_OEM_ANALYTICS_FILTERS = "RESET_OEM_ANALYTICS_FILTERS";
export const CHART_DATA_FETCHED_OEM = "CHART_DATA_FETCHED_OEM";
export const RESET_ALL = "RESET_ALL";
export const OEM_APP_STORE_ENGAGEMENT_DATA = "OEM_APP_STORE_ENGAGEMENT_DATA";
export const TOTAL_USERS_FETCHED = "TOTAL_USERS_FETCHED";
export const USER_GROWTH_FETCHED = "USER_GROWTH_FETCHED";
export const APPS_PER_USER_FETCHED = "APPS_PER_USER_FETCHED";
